import React, { useEffect, useState } from 'react';

// import { getDatabaseHeading } from '../../helpers/nameHelpers';

import ReactTable from 'react-table'
// import moment from 'moment';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';


import { Dialog } from '../../hooks/useDialog';

import Order from '../../account/components/OrderItem';

import { NumberFormatCustom } from '../../common/helpers';

import 'react-table/react-table.css'

const TF = (props) => {

    const [value, value_set] = useState(props.value);

    const { useNumberFormatter = true } = props;

    var inputProps = {
        inputProps: {
            style: {
                padding: 10,
            }
        }
    };

    if (useNumberFormatter) {
        inputProps.inputComponent = NumberFormatCustom;
    }

    return <div style={{ margin: 10, width: 250 }}><TextField fullWidth value={value ? value : ''} label={props.label}
        variant="outlined"
        InputProps={{ ...inputProps }}
        onChange={(e) => {
            value_set(e.target.value);

            props.onChange(e.target.value);
        }}
        onBlur={(e) => {
            if (value !== props.value)
                props.onChange(value);
        }} />
    </div>
}

const validatePassword = (p1, p2) => {
    return p1 && p2 && p1 === p2 && p1.length > 1;
}

const Main = (props) => {

    const { adminActions, adminState, editorActions } = props;

    const { users, orders } = adminState;

    const [editItem, editItem_set] = useState();
    // const [editItem2, editItem2_set] = useState();


    useEffect(() => {
        adminActions.fetchUsers();
    }, []);

    if (adminState.loading) {
        return <div>Loading...</div>
    }

    if (users.length === 0) {
        return <div>No Items</div>
    }

    const columns = [
        {
            Header: 'Email',
            accessor: 'email'
        },
        {
            Header: 'Full Name',
            accessor: 'fullName'
        },
        {
            Header: 'Orders',
            accessor: 'orders',
            Cell: props => {
                // console.log(props)
                return <div>
                    <div style={{ width: '100%' }}>{props.value}</div>
                    <div>
                        <Button color='primary' onClick={() => {
                            editItem_set({ type: 'orders', userId: props.original.id });
                            adminActions.getUserOrders({ userId: props.original.id });
                        }}>View Orders</Button>
                    </div>
                </div>
            }
        },
        // {
        //     Header: 'Portfolios',
        //     accessor: 'portfolios'
        // },
        {
            Header: 'Credits',
            accessor: 'credits',
            Cell: props => {
                return <div>
                    <div style={{ fontSize: 14 }}>
                        <div style={{ width: '100%', marginBottom: 5 }}>{props.value ? `CA$${props.value / 100}` : 'CA$0'}</div>
                        <div style={{ width: '100%' }}>{props.original.creditsUSD ? `US$${props.original.creditsUSD / 100}` : 'US$0'}</div>
                    </div>
                    <div>
                        <Button color='primary' onClick={() => {
                            editItem_set({ type: 'credits', userId: props.original.id, credits: props.original.credits, creditsUSD: props.original.creditsUSD, userName: props.original.fullName })
                        }}>Change Credits</Button>
                    </div>
                </div>
            }
        },
        {
            Header: 'Login Type',
            accessor: 'loginType',
            Cell: props => <div>
                <div style={{ width: '100%' }}>{props.value}</div>
                {props.value === 'Password' && <div>
                    <Button color='primary' onClick={() => {
                        editItem_set({ type: 'password', userId: props.original.id })
                    }}>Reset Password</Button>
                </div>}
            </div>
        },
    ];

    return <div>
        <div style={{ fontSize: 20, marginBottom: 20 }}>Database Entry</div>
        {editItem && editItem.type === 'credits' && <Dialog title={'Edit Database Value'} options={{ maxWidth: 'sm', fullWidth: true }}
            actionButtons={[<Button onClick={() => {
                adminActions.updateUserCredits({ userId: editItem.userId, credits: editItem.credits, creditsUSD: editItem.creditsUSD });
                editItem_set(null);

            }}>Save</Button>, <Button onClick={() => { editItem_set(null) }}>Cancel</Button>]}>
            <div>
                <div>User: {editItem.userName}</div>
                <div>
                    <TF value={editItem.credits / 100} onChange={(v) => {
                        editItem_set({ ...editItem, credits: v * 100 });
                    }} label={'Credits CAD'} />
                </div>
                <div>
                    <TF value={editItem.creditsUSD / 100} onChange={(v) => {
                        editItem_set({ ...editItem, creditsUSD: v * 100 });
                    }} label={'Credits USD'} />
                </div>
            </div>
        </Dialog>}
        {editItem && editItem.type === 'password' && <Dialog title={'Reset User Password'} options={{ maxWidth: 'sm', fullWidth: true }}
            actionButtons={[<Button
                disabled={!validatePassword(editItem.password, editItem.passwordVerify)}
                onClick={() => {
                    adminActions.resetUserPassword({ userId: editItem.userId, password: editItem.password });
                    editItem_set(null);

                }}>Save</Button>, <Button onClick={() => { editItem_set(null) }}>Cancel</Button>]}>
            <div>
                <div>User: {editItem.userName}</div>
                <div>
                    <TF value={editItem.password} onChange={(v) => {
                        editItem_set({ ...editItem, password: v });
                    }} label={'Password'} useNumberFormatter={false} />
                    <TF value={editItem.passwordVerify} onChange={(v) => {
                        editItem_set({ ...editItem, passwordVerify: v });
                    }} label={'Re-enter Password'} useNumberFormatter={false} />
                </div>
            </div>
        </Dialog>}
        {editItem && editItem.type === 'orders' && <Dialog title={'User Orders'} onClose={() => editItem_set(null)} options={{ maxWidth: 'lg', fullWidth: true }}>
            <div>
                {orders.loading && <div>
                    <div>Loading...</div>
                </div>}
                {!orders.loading && <div>
                    {orders.orders.map(e => <Order {...props} order={e} key={`ord_${e.id}`} editorActions={editorActions} hideDelete={true} />)}
                </div>}
            </div>
        </Dialog>}
        <ReactTable
            data={users}
            columns={columns}
            defaultSorted={[{
                id: 'closingDate',
                desc: true,
            }]}
        />
    </div>
}

export default Main;


// WEBPACK FOOTER //
// ./src/admin/components/Users.js